import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import GraphicUtils from "../../../../../utils/graphic-utils.js";

const NeighborhoodContent = ({data}) => {

    useEffect(() => {
        const values = [];
        const labels = [];

        data.neighborhoodsWithMoreAttendances?.sort((a, b) => b.qty - a.qty).forEach((item) => {
            labels.push(ReportUtils.formatText(item.neighborhood_name));
            values.push(item.qty);
        });

        ReportUtils.createExportableTable(labels, values, "Atendimentos por bairro");
        GraphicUtils.horizontalBarChart('neighborhood-total', values.slice(0, 10), labels.slice(0, 10), true);
    }, [data]);

    return (
        <>
            <div class="chart-report">
                <div class="chart-title mb-3">Atendimentos por bairro {data.neighborhoodsWithMoreAttendances.length >= 10 ? ' (TOP 10)' : ''}</div>
                <div class="chart-report bar-chart" id="neighborhood-total"></div>
            </div>
        </>
    );
};

export default NeighborhoodContent;